module.exports = __webpack_public_path__ + "static/media/Desktop_Actions_20.b46d9277.png";